<template>
  <div>
    <div
      class="position-absolute cursor-pointer"
      style="z-index: 9999999; right: 20px; top: 20px"
    >
      <h4>
        <img
          width="30"
          height="30"
          class="cursor-pointer"
          @click="$modal.hide($parent.name)"
          src="https://cdn.howuku.com/images/close-icon.png"
        />
      </h4>
    </div>
    <div class="announcement-container" style="z-index: 99999 !important">
      <div class="row">
        <div class="col-md-6 my-auto px-0">
          <img class="img-fluid" :src="message.img" />
        </div>
        <div class="col-md-6 announcement-content px-0">
          <div class="announcement-head mb-4">
            <h5>{{ message.title }}</h5>
          </div>
          <div class="announcement-body mb-4">
            <vue-markdown>{{ message.body }}</vue-markdown>
          </div>
          <div class="pt-4">
            <a :href="message.cta_link" @click="setConversion(message.key)">
              <button class="btn btn-cta btn-block">{{ message.cta }}</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const VueMarkdown = () => import('vue-markdown')

export default {
  props: ['message'],
  components: {
    VueMarkdown,
  },
  data: function () {
    return {}
  },
  mounted() {},
  methods: {
    setConversion(key) {
      this.$auditlog({
        modules: 'announcement',
        action: 'convert_' + key,
      })
    },
  },
}
</script>

<style scoped>
.announcement-container {
  padding: 60px 60px 60px 30px;
}

.announcement-head h5 {
  font-size: 34px;
  font-family: 'Rubik', sans-serif;
  font-weight: 900;
}

.announcement-body {
  font-size: 18px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.announcement-content button {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Announcement.vue